import moment, { Moment } from 'moment';

// Valor de un selector de fecha (DatePicker, TimePicker, DateTimePicker) tal cual lo da. A medio escribir es una fecha no
// válida: se guarda igualmente en el estado para que el campo conserve lo escrito (si se guardara null, el selector se vaciaba).
// Antes se aceptaba con `date && setX(date)` y una fecha no válida llegaba a la API como null.
export type ValorFecha = Date | Moment | null;

// Fecha real de un valor del selector: null si está vacío o no es una fecha válida. Es lo que se valida y lo que se envía.
export const aFecha = (valor: ValorFecha | undefined): Date | null => {
    if (!valor) return null;
    const fecha = moment(valor);
    return fecha.isValid() ? fecha.toDate() : null;
};

// Para estados tipados como Date (agenda, clases): la fecha real o una fecha no válida (new Date(NaN)), que el selector
// tampoco vacía (solo vacía el campo con null). Antes de usarla, comprobar con esFechaValida.
export const aDateOInvalida = (valor: ValorFecha | undefined): Date => aFecha(valor) ?? new Date(NaN);

export const esFechaValida = (valor: ValorFecha | undefined): boolean => aFecha(valor) !== null;
